var MuiDialog = {
    /* your custom class style overrides here */
    paper: {
        borderRadius: 8,
    },
};
export default MuiDialog;
//# sourceMappingURL=MuiDialog.js.map